$(document).ready(function(){
    $(".contentBlock").find("table").wrap("<div class='styledTable'></div>");
});
$(document).ready(function () {
  $('.js-openMenu').on("click", function () {
    // $(this).toggleClass('active');
    $('.mobileMenu').toggleClass('opened');
    setTimeout(function(){
      $('body').toggleClass('noscroll');
      $('html').toggleClass('noscroll');
    }, 1000);
    
  });
  $('.js-close').on("click", function () {
    $('.mobileMenu').removeClass('opened');
    $('body').removeClass('noscroll');
    $('html').removeClass('noscroll');
  });
  
  $('body').on("click", '.js-prev', function () {
    var el = $(this);
    $(".mobileMenu ul.opened").removeClass("opened");
    $("[data-menu].actived").removeClass("actived");
    $(".js-prev").remove();
    $('.mobileMenu__inner > .mobileMenu__list > li').show();
  });

  $('.mobileMenu li').each(function() {
    if ( $(this).find('ul').length ) {
      $(this).addClass('withSubmenu');
    }
  });

  $("[data-menu]:not(.actived)").on("click", function (e) {
    if( $(this).hasClass('actived')) { 
      window.location.href = $(this).attr('href');
    } else {
      e.preventDefault();
      var el = $(this);
      el.addClass("actived");
      el.next('ul').addClass("opened").parent().siblings().hide();
      $('.mobileMenu__tools').append("<a class='js-prev mobilePrev'></a>");
    }
    
  });

  $('.js-searchBox2 .searchBox2__icon').on('click', function() {
    $(this).parent().toggleClass('active');
    $('.js-searchBox2 input').focus();
    $('.mobileMenu__language').toggleClass('hide');
  });

  

});

$(document).ready(function () {

  $('.js-slider').slick({
      arrows: true,
      speed: 700,
      fade: true,
      autoplay: false,
      autoplaySpeed: 7000,
      dots: true,
      infinite: true,
      autoplay: true
  });

  //language
  $('.language__select').on('click', function() {
      $('.language__list').slideToggle('fast');
      return false;
  });



  // js-up
  $(".js-up").on("click", function () {
      var body = $("html, body");
      body.stop().animate({scrollTop: 0}, 1500, 'swing');
  });

  // counter
  if ($('.circles').length) {

    function startCounter() {
        var hT = jQuery('.circles').offset().top,
            hH = jQuery('.circles').outerHeight(),
            wH = jQuery(window).height();
        if (jQuery(window).scrollTop() > hT+hH-wH) {
            jQuery(window).off("scroll", startCounter);
            jQuery('.js-circles__itemNumber').each(function (index) {
                $(this).prop('Counter',0).animate({
                Counter: $(this).text()
                }, {
                duration: 2000,
                easing: 'swing',
                step: function (now) {
                    $(this).text((Math.ceil(now)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "));
                }
                });
            });
        }
    }
    jQuery(window).scroll(startCounter);

  }

  // lazyloading
    const observer = lozad(); // lazy loads elements with default selector as '.lozad'
    observer.observe();
  //aos

  // selectize
  if ( $('.js-filters__input--select') ) {
    $('.js-filters__input--select').selectize({
        allowEmptyOption: false
    });
  }

// mobile search
$('.js-header__search').on('click', function(){
    $('.header__searchBox form').toggleClass('header__searchBoxForm--hidden');
    $('.header__searchBox').slideToggle(300);
});



var searchbox = $('#js-searchBox');
var searchphrase = "";
var changeSearch = false;
searchboxSelectize = searchbox.selectize({
    placeholder: window.Laravel.lang.search.placeholder,
    options: [],
    onChange: function(value) {
      changeSearch = true;
      $("select[name='s'] option:selected").val(value);
      $("#searchBox__form").submit();
    },
    score: function(search) {
        var score = this.getScoreFunction(search);
        // console.log(score);
        return function(item) {
            return 1 + score(item);
        };
    },
    load: function(query, callback) {
      if (query.length < 3){
        searchbox.selectize()[0].selectize.clearOptions();
        return callback();
      }

      var currentRequest = null;

      currentRequest = jQuery.ajax({
          type: 'POST',
          data: {
            'phrase':query,
            '_token': window.Laravel.csrfToken,
            'lang': $('html').attr('lang')
          },
          url: '/module/search/hint',
          beforeSend : function()    {
            //   console.log(currentRequest);
              if(currentRequest != null) {
                  currentRequest.abort();
              }
          },
          success: function(data) {
              var collection = [];
              searchbox.selectize()[0].selectize.clearOptions();
              if(Object.keys(data.results).length>0){
                // console.log(query);
                for (var prop in data.results) {
                  collection.push({
                        id : parseInt(prop),
                        name: data.results[prop][1],
                        text: data.results[prop][1],
                        value: data.results[prop][1]
                    });
                }
              }else{

              }
              //searchbox.selectize()[0].selectize.refreshOptions();
              callback(collection);
          },
          error:function(e){
            console.log("error");
          }
      });
    }
  });

  $("#searchBox__form").bind("submit",function(e){
    searchprase = $("#js-searchBox-selectized").val();
    if(!changeSearch)
      $("select[name='s'] option:selected").val(searchphrase);
    //$("#searchBox__form").append("<input type='hidden' name='s' value='"+searchphrase+"'/>");
  });

  $("#js-searchBox-selectized").bind("change",function(e){
    searchphrase = $(this).val();
  });
  $("#js-searchBox-selectized").bind("keyup",function(e){
    searchphrase = $(this).val();
  });
  $("#js-searchBox-selectized").bind("blur",function(e){
    $(this).val(searchphrase);
  });
  $('.js-searchBox__button').on('click', function(){
    //$("#searchBox__form").append("<input type='hidden' name='s' value='"+searchphrase+"'/>");
    $("#searchBox__form").submit();
  });

  $('#cartForm').bind("keypress", function(e) {
            if (e.keyCode == 13) {
                return false;
            }
  });
}); // end document ready



$(window).on("scroll", function () {

    // js-up
    var scroll = $(window).scrollTop();
    if (scroll > 600) {
            $(".js-up").addClass("visible");
    } else {
            $(".js-up").removeClass("visible");
  }

    // scrolled menu
    if ($(window).width()>1240){

      if ($(window).scrollTop() > 0){
        $('.js-header').addClass('header--scrolled');
     } else {
            $('.js-header').removeClass('header--scrolled');
     }

    }

}); // end onscroll


function setTimeCoockie() {
  let backgrCoockie = $('#CybotCookiebotDialog');
  let windowCoockie = $('#CybotCookiebotDialogBodyUnderlay');
  backgrCoockie.attr('style','display:flex!important;');
  windowCoockie.attr('style','display:flex!important;');
}

setTimeout(setTimeCoockie, 4000);

//# sourceMappingURL=front.js.map
